module.exports = __webpack_public_path__ + "img/鬼箭羽.4a1d83ee.jpg";